import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import ApiConfigDisplay from './components/ApiConfigDisplay';

// Pages
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import EmailVerification from './pages/EmailVerification';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import Finance from './pages/Finance';
import Support from './pages/Support';
import SupportDashboard from './pages/SupportDashboard';
import TicketDetail from './pages/TicketDetail';
import Profile from './pages/Profile';
import Subscription from './pages/Subscription';
import AccountSettings from './pages/AccountSettings';
import Invoices from './pages/Invoices';
import InvoiceDetail from './pages/InvoiceDetail';
import NotificationSettings from './pages/NotificationSettings';
import BulkUpload from './pages/BulkUpload';
import Chat from './pages/Chat';
import Analytics from './pages/Analytics';
import Wishlist from './pages/Wishlist';
import BackendDashboard from './pages/BackendDashboard';
import DeliveryPartnerDashboard from './pages/DeliveryPartnerDashboard';
import LoyaltyDashboard from './pages/LoyaltyDashboard';
import { ReturnsList } from './pages/Returns';
import ReturnRequestPage from './pages/ReturnRequestPage';
import EmailTest from './pages/EmailTest';
import MonitoringDashboard from './pages/MonitoringDashboard';
import PublicProfile from './pages/PublicProfile';
import ApiLogs from './pages/ApiLogs';
import UserEngagement from './pages/UserEngagement';
import KnowledgeBase from './pages/KnowledgeBase';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/verify-email/:token" element={<EmailVerification />} />
            
            {/* Public Profile - No authentication required */}
            <Route path="/public-profile/:userId" element={<PublicProfile />} />
            
            <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/products" element={<PrivateRoute><Products /></PrivateRoute>} />
            <Route path="/products/:id" element={<PrivateRoute><ProductDetail /></PrivateRoute>} />
            <Route path="/orders" element={<PrivateRoute><Orders /></PrivateRoute>} />
            <Route path="/orders/:id" element={<PrivateRoute><OrderDetail /></PrivateRoute>} />
            <Route path="/finance" element={<PrivateRoute><Finance /></PrivateRoute>} />
            <Route path="/subscription" element={<PrivateRoute><Subscription /></PrivateRoute>} />
            <Route path="/support" element={<PrivateRoute><Support /></PrivateRoute>} />
            <Route path="/support-dashboard" element={<PrivateRoute><SupportDashboard /></PrivateRoute>} />
            <Route path="/support/tickets/:id" element={<PrivateRoute><TicketDetail /></PrivateRoute>} />
            <Route path="/privacy-settings" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/account-settings" element={<PrivateRoute><AccountSettings /></PrivateRoute>} />
            <Route path="/invoices" element={<PrivateRoute><Invoices /></PrivateRoute>} />
            <Route path="/invoices/:id" element={<PrivateRoute><InvoiceDetail /></PrivateRoute>} />
            <Route path="/notification-settings" element={<PrivateRoute><NotificationSettings /></PrivateRoute>} />
            <Route path="/bulk-upload" element={<PrivateRoute><BulkUpload /></PrivateRoute>} />
            <Route path="/chat" element={<PrivateRoute><Chat /></PrivateRoute>} />
            <Route path="/chat/:chatId" element={<PrivateRoute><Chat /></PrivateRoute>} />
            <Route path="/analytics" element={<PrivateRoute><Analytics /></PrivateRoute>} />
            <Route path="/wishlist" element={<PrivateRoute><Wishlist /></PrivateRoute>} />
            <Route path="/loyalty" element={<PrivateRoute><LoyaltyDashboard /></PrivateRoute>} />
            <Route path="/returns" element={<PrivateRoute><ReturnsList /></PrivateRoute>} />
            <Route path="/orders/:orderId/return" element={<PrivateRoute><ReturnRequestPage /></PrivateRoute>} />
            <Route path="/backend-dashboard" element={<PrivateRoute><BackendDashboard /></PrivateRoute>} />
            <Route path="/delivery-partner-dashboard" element={<PrivateRoute><DeliveryPartnerDashboard /></PrivateRoute>} />
            <Route path="/email-test" element={<PrivateRoute><EmailTest /></PrivateRoute>} />
            <Route path="/monitoring" element={<PrivateRoute><MonitoringDashboard /></PrivateRoute>} />
            <Route path="/api-logs" element={<PrivateRoute><ApiLogs /></PrivateRoute>} />
            <Route path="/user-engagement" element={<PrivateRoute><UserEngagement /></PrivateRoute>} />
            <Route path="/knowledge-base" element={<PrivateRoute><KnowledgeBase /></PrivateRoute>} />
            
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <ToastContainer position="top-right" autoClose={3000} />
          <ApiConfigDisplay />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
